import type { ClientSession } from '@arnold/common/types';

import { logout } from '../auth';
import { connect } from '../routes';
import type { RuntimeConfig } from '../types';
import { EXTERNAL_USER_ID_QUERY_PARAM } from '../utils/constants';

export async function connectRouteHandler(
  config: RuntimeConfig,
  sessionInfo: ClientSession | void,
): Promise<boolean> {
  if (!sessionInfo || !location.pathname.endsWith(connect)) {
    return false;
  }

  const params = new URLSearchParams(location.search);
  const externalUserId = params.get(EXTERNAL_USER_ID_QUERY_PARAM);

  if (!externalUserId) {
    return false;
  }

  await logout(config);

  return true;
}
